import { render } from "./homeData.vue?vue&type=template&id=81fe0a30&scoped=true"
import script from "./homeData.vue?vue&type=script&lang=js"
export * from "./homeData.vue?vue&type=script&lang=js"

import "./homeData.vue?vue&type=style&index=0&id=81fe0a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fe0a30"]])

export default __exports__